<template>
    <div >
        <aicc-gnb ref="gnb" :menuItems="gnbMenuItems" @gnb-selected="onGnbSelected" :title="title" :subTitle="subTitle" @onClickMyInfo="onClickMyInfo" @onClickPersonalInfo="onClickPersonalInfo"/>
        <div class="body-container" :class="lnbStateClass">
            <div v-show="lnbShowed" class="left-container">
                <aicc-lnb ref="lnb" class="lnb-area" :menuItems="lnbMenuItems" :showNewCampagin="lnbShowNewCampaign" :showMyTrial="lnbShowMyTrial"/>
            </div>
             <div ref="contentsContainer" class="right-container">
                <keep-alive :include="keepAlivePages">
                    <router-view :key="$route.fullPath" class="-page-root-container"/>
                </keep-alive>
            </div>          
        </div>
        <aicc-footer v-if="$store.getters.isFooterShowed" style="height:48px" @onClickPersonalInfo="onClickPersonalInfo"/>
        <ur-snackbar ref="snackbar" :duration="3000"/>
        <my-info-modal ref="myInfoModal"/>
        <service-personal-info-modal ref="servicePersonalInfoModal" :title="servicePersonalInfo.title" :contents="servicePersonalInfo.contents" :oldTermsNoticeList="servicePersonalInfo.oldTermsNoticeList"/>
    </div>
</template>
<script>
import AICCGnb from '../AICCGnb/AICCGnb';
import AICCLnb from '../AICCLnb/AICCLnb';
import AICCFooter from '../AICCFooter/AICCFooter';
import myInfoModal from '../AICCFrame/components/myInformationModal.vue';
import servicePersonalInfoModal from '../AICCFrame/components/ServicePersonalInfoModal.vue';
import AuthManager from '~system/auth/AuthManager';
import ReplyCode from '~modules/AI/js/ReplyCode.js';

export default {
    name: 'aicc-frame',
    components: {
        aiccGnb: AICCGnb,
        aiccLnb: AICCLnb,
        aiccFooter: AICCFooter,
        myInfoModal,
        servicePersonalInfoModal,
    },

    data() {
        return {
            keepAlivePages: utils.getConfigurationValue('CFG_CMU_KEEP_ALIVE_PAGE') || 'dummy',
            gnbMenuItems: [],
            lnbMenuItems: [],
            lnbShowNewCampaign: false,
            lnbShowMyTrial: false,
            contentsSize:{
                width:0,
                height:0,
            },
            servicePersonalInfo:{
                title:'',
                contents:'',
                oldTermsNoticeList: [],
            },
            termsNoticeList: [],
        }
    },
    created(){
    },
    mounted(){
        if (this.$store.getters.isLoggedIn) { // 로그인 상태에서만 포털 초기 데이터 조회
            this.loadInitData().then(() => {
                this.$nextTick(() => {
                    this.checkContentsSize();
                });
            });
        
            http.request('Frame', 'DTS_AIM_00001', {})
            .then(res => {
                this.$store.commit('setContactCenterName', res.data.aiccInfo.contactCenterNm);
            });
            
            this.getTerms();
        } else { // 로그인 전에 수행하는 로직
            this.checkContentsSize();
            this.getPrivacyPolicy();
            this.getContactCenterNm();
        }
        this.$store.commit('syncGnbMenu');
        //this.funcResize = _.debounce(this.checkContentsSize, 200);
        //window.addEventListener('resize', this.funcResize);
    },
    beforeDestroy() {
        //window.removeEventListener('resize', this.funcResize);
    },
    watch:{
        lnbShowed(){
            this.checkContentsSize(true);
        },
        lnbCollapsed(){
            this.checkContentsSize(true);
        },
    },
    computed:{
        title(){
            let title = this.$store.getters.contactCenterName;
            if(!title) {
                //title = this.$store.getters.userInfo.tenantId;
                title = 'AI Contact Center';
            }
            return title;

            /*
            let userInfo = this.$store.getters.userInfo;
            let tenantName = userInfo.tenantName;
            let tenantId = userInfo.tenantId;
            if(tenantName && tenantName != null && tenantName != '') {
                return tenantName;
            } else {
                return tenantId;;
            }
            */

           
        },
        subTitle(){
            return 'AICC Service';
        },
        gnbShowed(){
            return this.$store.getters.isGnbShowed;
        },
        lnbShowed(){
            return this.$store.getters.lnbShowed && this.$store.getters.isGnbMenuShowed;
        },
        lnbCollapsed(){
            return this.$store.getters.lnbCollapsed;
        },
        lnbExtended() {
            return this.$store.getters.lnbExtended;
        },
        lnbStateClass() {
            let clazz = [{
                '-lnb--collapse': this.lnbShowed && this.lnbCollapsed,
                '-lnb--expand': this.lnbShowed && !this.lnbCollapsed,
                '-lnb--show': this.lnbShowed,
                '-lnb--hide': !this.lnbShowed,
                '-lnb--extend': this.lnbShowed && !this.lnbCollapsed && this.lnbExtended,
            },];
            if(this.$store.getters.isFooterShowed === true) {
                clazz.push('footer');
            }
            return clazz;
            /*
            return [{
                '-lnb--collapse': this.lnbShowed && this.lnbCollapsed,
                '-lnb--expand': this.lnbShowed && !this.lnbCollapsed,
                '-lnb--show': this.lnbShowed,
                '-lnb--hide': !this.lnbShowed,
                '-lnb--extend': this.lnbShowed && !this.lnbCollapsed && this.lnbExtended,
            },];
            */
        },
        frameRootClass() {
            return [
                this.hideMenus? 'app-frame-root__popup' : '',
                this.isGnbShowed? '-gnb--show' : '-gnb--hide',
                this.gnbExtended? '-gnb--extend' : '',
                this.lnbShowed? '-lnb--show' : '-lnb--hide',
            ];
        },
        isGnbMenuShowed(){
            return this.$store.getters.isGnbMenuShowed;
        }
    },
    methods:{
        checkContentsSize(fromLnb){
            this.$nextTick(() => {
                let changed = false;
                if(!this.$refs.contentsContainer) {
                    return;
                }
                if (this.contentsSize.width !== this.$refs.contentsContainer.getBoundingClientRect().width) {
                    this.contentsSize.width = this.$refs.contentsContainer.getBoundingClientRect().width;
                    changed = true;
                }
                if (this.contentsSize.height !== this.$refs.contentsContainer.getBoundingClientRect().height) {
                    this.contentsSize.height = this.$refs.contentsContainer.getBoundingClientRect().height;
                    changed = true;
                }
                if(changed) {
                    this.$root.$emit('frame-resize', this.contentsSize);
                    if(fromLnb === true) {
                        this.$root.$emit('lnb-resize', this.contentsSize);
                    }
                }
            });
        },
        loadInitData(){
            return new Promise((resolve, reject) => {
                http.getGnbMenus().then(res => {
                    this.gnbMenuItems = res;
                    this.$store.commit('setApplications', res);
                    this.syncMenuState();
                    resolve();
                }).catch(error => {
                    reject(error);
                });
            });
        },
        syncMenuState(){
            if(this.$router.currentRoute) {
                for(let gnbIndex in this.gnbMenuItems) {
                    let gnb = this.gnbMenuItems[gnbIndex];
                    http.getLnbMenu(gnb.applicationId).then(res => {
                        for(let lnbIndex in res) {
                            if(res[lnbIndex].pageId === this.$router.currentRoute.name) {
                                this.$refs['gnb'].selectedItem = gnb;
                                this.$store.commit('setCurrentApplication', gnb);
                                this.setLnbMenuStateWithPageId(gnb, res, res[lnbIndex].pageId);
                                break;
                                //this.$refs['lnb'].clickMenu(res[lnbIndex]);
                            }
                        }
                    })
                }
            }
        },
        syncMenuStateByPageId(pageId) {
            if(pageId) {
                for(let gnbIndex in this.gnbMenuItems) {
                    let gnb = this.gnbMenuItems[gnbIndex];
                    http.getLnbMenu(gnb.applicationId).then(res => {
                        for(let lnbIndex in res) {
                            if(res[lnbIndex].pageId === pageId) {
                                this.$refs['gnb'].selectedItem = gnb;
                                this.$store.commit('setCurrentApplication', gnb);
                                this.setLnbMenuStateWithPageId(gnb, res, pageId);
                                break;
                                //this.$refs['lnb'].clickMenu(res[lnbIndex]);
                            }
                        }
                    })
                }
            }
        },
        searchLnb(){

        },
        onGnbSelected(item){
            if(item.applicationId && this.$store.getters.applicationId === item.applicationId) {
                return;
            }

            this.$store.commit('setCurrentApplication', item);
            

            http.getLnbMenu(item.applicationId).then(res => {
                this.setLnbMenuState(item, res, true);
            });
        },
        setLnbMenuState(application, menuItems, goFirstMenu){
            if(application.applicationId && application.applicationId === 'APP_OUTBOUND_BOT_SERVICE') {
                this.lnbShowNewCampaign = true;
            } else {
                this.lnbShowNewCampaign = false;
            }

            if(application.applicationId && application.applicationId === 'APP_MY_AICC') {
                this.lnbShowMyTrial = true;
            } else {
                this.lnbShowMyTrial = false;
            }


            this.lnbMenuItems = menuItems;

            const menuUseYn = application.applicationMenuUseYn === 'Y'? true: false;
            const menuFoldYn = application.applicationMenuFoldYn === 'Y'? true: false;
            const menuItemFoldYn = application.applicationFolderFoldYn === 'Y'? true: false;
            
            menuUseYn? this.$store.commit('showLNB'):this.$store.commit('hideLNB');
            menuFoldYn? this.$store.commit('collapseLNB'):this.$store.commit('expandLNB');
            menuItemFoldYn? this.$store.commit('collapseLNBItems'):this.$store.commit('expandLNBItems');
            this.$store.commit('showLnbDefaultMenu');
            this.$store.commit('hideFooter');
            if(goFirstMenu && goFirstMenu === true) {
                const queue = [...menuItems];
                let firstMenu;
                while (queue.length) {
                    const menu = queue.shift();
                    if(!firstMenu) {
                        firstMenu = menu;
                    }   
                    if (!menu.state) {
                        menu.state = {};
                    }
                    if (menuItemFoldYn) {
                        menu.state.expanded = false;
                    } else {
                        menu.state.expanded = true;
                    }
                    _.forEach(menu.children, child => queue.push(child));
                }
                const defaultPage = application.applicationBasicsPageId;
                if (defaultPage && defaultPage.trim() !== '') {
                    utils.goPage(defaultPage);
                }
                this.$refs.lnb.clickMenu(firstMenu);
            }
        },
        setLnbMenuStateWithPageId(application, menuItems, pageId){
            if(application.applicationId && application.applicationId === 'APP_OUTBOUND_BOT_SERVICE') {
                this.lnbShowNewCampaign = true;
            } else {
                this.lnbShowNewCampaign = false;
            }

            if(application.applicationId && application.applicationId === 'APP_MY_AICC') {
                this.lnbShowMyTrial = true;
            } else {
                this.lnbShowMyTrial = false;
            }


            this.lnbMenuItems = menuItems;

            const menuUseYn = application.applicationMenuUseYn === 'Y'? true: false;
            const menuFoldYn = application.applicationMenuFoldYn === 'Y'? true: false;
            const menuItemFoldYn = application.applicationFolderFoldYn === 'Y'? true: false;
            
            menuUseYn? this.$store.commit('showLNB'):this.$store.commit('hideLNB');
            menuFoldYn? this.$store.commit('collapseLNB'):this.$store.commit('expandLNB');
            menuItemFoldYn? this.$store.commit('collapseLNBItems'):this.$store.commit('expandLNBItems');
            this.$store.commit('showLnbDefaultMenu');
            this.$store.commit('hideFooter');
            console.log(menuItems);
            for(let menuIndex in menuItems) {
                const menu = menuItems[menuIndex];
                if(menu.pageId && menu.pageId === pageId) {
                    this.$refs.lnb.setMenu(menu);
                    break;
                }
            }
        },
        onClickMyInfo() {
            this.$refs['myInfoModal'].open();
        },

        // Footer 서비스 이용약관 눌렀을 때
        // 향후 서비스 이용약관 Footer(GNB메뉴까지?) 추가 예정
        // 추가 이후 하단 Function 연동 예정
        onClickServiceInfo(){
            // 서비스 이용약관의 TypeCode : A
            this.showTerms('A');
        },
        // Footer 개인정보 처리방침 눌렀을 때
        onClickPersonalInfo(){
            // 개인정보 처리방침의 TypeCode : B
            this.showTerms('B');
        },
        getTerms(){
            http.request('Frame', 'DTS_AIM_00013', {
            }).then(res => {
                const termsList = res.data.termsList;
                this.termsNoticeList = termsList;
                const oldTermsList = res.data.oldTermsList;
                this.servicePersonalInfo.oldTermsNoticeList = oldTermsList;
            });
        },
        getPrivacyPolicy() {
            AuthManager.getPrivacyPolicy().then(data => {
                if (data.reply.code === ReplyCode.NO_ERROR) { // 개인정보 처리방침 조회 성공
                    const termsList = data.termsList;
                    this.termsNoticeList = termsList;
                    const oldTermsList = data.oldTermsList;
                    this.servicePersonalInfo.oldTermsNoticeList = oldTermsList;
                } else {
                    console.warn('err : ', data.reply.korMsg);
                }
            }).catch(err => {
                console.warn('err : ', err);
            });
        },
        getContactCenterNm() {
            const ccUrl = aiccUtils.urlUtil.getCcUrl();
            AuthManager.getContactCenterNm(ccUrl).then(data => {
                if (data.reply.code === ReplyCode.NO_ERROR) { // AICC 이름 조회 성공
                    this.$store.commit('setContactCenterName', data.contactCenterNm);
                } else {
                    console.log('no contactCenterNm');
                }
            }).catch(err => {
                console.warn('err : ', err);
            });
        },
        showTerms(typeCode){
            let isShow = false;
            // 전체 고지 목록 중 typeCode가 일치하는 고지만 표시
            for(let index in this.termsNoticeList) {
                const terms = this.termsNoticeList[index];
                // termsCategoryCode === 'B' : Terms이 고지용인지 판별
                if(terms.termsCategoryCode === 'B' &&  terms.termsTypeCode === typeCode) {
                    this.servicePersonalInfo.title = terms.termsName;
                    this.servicePersonalInfo.contents = terms.termsContent;
                    isShow = true;
                    break;
                }
            }
            this.$nextTick(() => {
                if(isShow === true) {
                    this.$refs['servicePersonalInfoModal'].open();
                }
            })
        },
        showSnackBar(message){
            this.$refs.snackbar.show({text: message});
        },
    },

}
</script>
<style scoped>
    .gnb {
        height:60px;
        background-color: #0c1533;
    }
    .body-container {
        top:60px;
    }
    .footer {
       margin-bottom: 48px;
    }
    .lnb-area {
        overflow: auto;
        background-color: #eaedf4;
    }
</style>